<template>
    <div>
        <header class="header">
            <a href="/" class="logo">
                <v-img
                alt="Vuetify Logo"
                class="main-logo" width="128"
                contain
                :src="require('../../assets/logo_1.png')"
                transition="scale-transition"
                style="padding-top: 15px;"
                />
            </a>
            <input class="menu-btn" type="checkbox" id="menu-btn" />
            <label class="menu-icon" for="menu-btn"><span class="navicon"></span></label>
            <ul class="menu">
                <li style="padding-top:3px;" id="icon">
                    <a href="#" target="_blank"><i class="fab fa-twitter"></i></a>
                </li>
                <li style="padding-top:3px;" id="icon">
                    <a href="https://www.facebook.com/zhyldyz.academy" target="_blank"><i class="fab fa-facebook-square"></i></a>
                </li>
                <li style="padding-top:3px;" id="icon">
                    <a href="https://api.whatsapp.com/send/?phone=%2B996704949501&text&app_absent=0" target="_blank"><i class="fab fa-whatsapp"></i></a>
                </li>
                <li style="padding-top:3px;" id="icon">
                    <a href="https://www.instagram.com/zhyldyz_academy/" target="_blank"><i class="fab fa-instagram"></i></a>
                </li>
                <li :class="{'active': '/' === $route.path || '/student/main' === $route.path}" class="path">
                    <a @click="goTo('Home')" style="font-weight: 700;">{{$t('home')}}</a>
                    <!--<ul class="sub-menu">
                        <li><a href="index.html">Home 01</a></li>
                        <li><a href="index-2.html">Home 02</a></li>
                        <li><a href="index-3.html">Home 03</a></li>
                        <li><a href="#">Header Versions</a>
                            <ul class="sub-menu">
                                <li><a href="index.html">Header 01</a></li>
                                <li><a href="index-2.html">Header 02</a></li>
                                <li><a href="index-3.html">Header 03</a></li>
                            </ul>
                        </li>
                    </ul> /.sub-menu -->
                </li>
                <!--<li>
                    <a href="#">Pages</a>
                    <ul class="sub-menu">
                        <li><a href="about.html">About Page</a></li>
                        <li><a href="gallery.html">Gallery</a></li>
                        <li><a href="pricing.html">Pricing Plans</a></li>
                        <li><a href="faq.html">FAQ'S</a></li>
                    </ul> 
                </li>/.sub-menu -->
                <li :class="{'active': '/courses' === $route.path || '/student/courses' === $route.path}" class="path">
                    <a @click="goTo('Courses')" style="font-weight: 700;">{{$t('courses')}}</a>
                    <!--<ul class="sub-menu">
                        <li><a href="courses.html">Courses</a></li>
                        <li><a href="course-details.html">Course Details</a></li>
                    </ul> /.sub-menu -->
                </li>
                <li :class="{'active': '/teachers' === $route.path || '/student/teachers' === $route.path}" class="path">
                    <a @click="goTo('Teachers')" style="font-weight: 700;">{{$t('teachers')}}</a>
                    <!--<ul class="sub-menu">
                        <li><a href="teachers.html">Teachers</a></li>
                        <li><a href="team-details.html">Teachers Details</a></li>
                        <li><a href="become-teacher.html">Become Teacher</a></li>
                    </ul> /.sub-menu -->
                </li>
                <li :class="{'active': '/news' === $route.path || '/student/news' === $route.path}" class="path">
                    <a @click="goTo('News')" style="font-weight: 700;">{{$t('news')}}</a>
                    <!-- <ul class="sub-menu">
                        <li><a href="news.html">News Page</a></li>
                        <li><a href="news-details.html">News Details</a></li>
                    </ul>/.sub-menu -->
                </li>
                <li :class="{'active': '/about' === $route.path || '/student/about' === $route.path}" class="path">
                    <a @click="goTo('About')" style="font-weight: 700;">{{$t('about')}}</a>
                </li>
                 
            </ul>   
            <select class="black--text" id="lang" v-model="$i18n.locale"  style="border: 1px inset #8A8FA6; padding: 7px;border-radius: 12px;">
                  <option value="kg" selected>🇰🇬 KG</option>
                  <option value="en">🇺🇸 En</option>
            </select>  
        </header>
    </div>
</template>
<script>
export default {
    name: "Header",
    data: () => ({}),
    computed: {
        loggedIn () {
            return this.$store.state.account.user;
        },
    },
    mounted() {
        console.log(this.loggedIn)
    },
    methods: {
        goTo (url) {
            this.link = url;
            if(this.loggedIn.role === 'STUDENT'){
                
                switch (url) {
                    case 'Courses':
                    this.$router.push({ name: 'studentCourses', path: '/student/courses' }).catch(() => {});
                    break;
                    case 'Teachers':
                    this.$router.push({ name: 'studentTeachers' }).catch(() => {});
                    break;
                    case 'News':
                    this.$router.push({ name: 'studentNews' }).catch(() => {});
                    break;
                    case 'About':
                    this.$router.push({ name: 'studentAbout' }).catch(() => {});
                    break;
                    case 'Home':
                    this.$router.push({ name: 'studentMain' }).catch(() => {});
                    break;
                }
            }
            else if(!this.loggedIn.role) {
                switch (url) {
                    case 'Courses':
                    this.$router.push({ name: 'Courses' }).catch(() => {});
                    break;
                    case 'Teachers':
                    this.$router.push({ name: 'Teachers' }).catch(() => {});
                    break;
                    case 'News':
                    this.$router.push({ name: 'News' }).catch(() => {});
                    break;
                    case 'About':
                    this.$router.push({ name: 'About' }).catch(() => {});
                    break;
                    case 'Home':
                    this.$router.push({ name: 'Main' }).catch(() => {});
                    break;
                }
            }
      },
    }
}
</script>
<style>
#lang {
  margin-top: 30px;
}
.header {
  background-color: #f1f0f0;
  box-shadow: 1px 1px 4px 0 rgba(0,0,0,.1);
  position: fixed;
  top: 35px;
  width: 100%;
  z-index: 9999;
}

.header ul {
  margin: 0;
  padding: 0;
  list-style: none;
  overflow: hidden;
  background-color: #f1f0f0;
}

.header li a {
  display: flex;
  padding: 30px 20px;
  border-right: 1px solid #f1f0f0;
  text-decoration: none;
  color:#828383;
  font-weight: bold;
  left: 0;
}
.active {
  color:#f16101;
}
.path:hover {
  color:#f16101;
}
.header li a:hover,
.header .menu-btn:hover {
  color: #f16101;
}
.header li a:active,
.header .menu-btn:active {
  color: #f16101;
}

.header .logo {
  display: block;
  float: left;
  font-size: 2em;
  padding: 20px 20px;
  text-decoration: none;
}

/* menu */

.header .menu {
  clear: both;
  max-height: 0;
  transition: max-height .2s ease-out;
}

/* menu icon */

.header .menu-icon {
  cursor: pointer;
  display: inline-block;
  float: right;
  padding: 32px 20px;
  position: relative;
  user-select: none;
  color: #335CA2;
  
}

.header .menu-icon .navicon {
  background: #335CA2;
  display: block;
  height: 2px;
  position: relative;
  transition: background .2s ease-out;
  width: 18px;
}

.header .menu-icon .navicon:before,
.header .menu-icon .navicon:after {
  background: #335CA2;
  content: '';
  display: block;
  height: 100%;
  position: absolute;
  transition: all .2s ease-out;
  width: 100%;
}

.header .menu-icon .navicon:before {
  top: 5px;
}

.header .menu-icon .navicon:after {
  top: -5px;
}

/* menu btn */

.header .menu-btn {
  display: none;
}

.header .menu-btn:checked ~ .menu {
  max-height: 390px;
}

.header .menu-btn:checked ~ .menu-icon .navicon {
  background: transparent;
}

.header .menu-btn:checked ~ .menu-icon .navicon:before {
  transform: rotate(-45deg);
}

.header .menu-btn:checked ~ .menu-icon .navicon:after {
  transform: rotate(45deg);
}

.header .menu-btn:checked ~ .menu-icon:not(.steps) .navicon:before,
.header .menu-btn:checked ~ .menu-icon:not(.steps) .navicon:after {
  top: 0;
}

/* 48em = 768px */

@media (min-width: 48em) {
  .header li {
    float: left;
  }
  .header li a {
    padding: 40px 20px;
  }
  .header .menu {
    clear: none;
    float: left;
    max-height: none;
  }
  .header .menu-icon {
    display: none;
  }
  .llogin {
    display: none;
  }
}
@media screen and (min-width: 300px) and (max-width: 600px) {
  #icon {
    display: none;
  }
  #lang {
    display: none;
  }
  .header {
  background-color: #f1f0f0;
  box-shadow: 1px 1px 4px 0 rgba(0,0,0,.1);
  position: fixed;
  top: 60px;
  width: 100%;
  z-index: 9999;
}

.header ul {
  margin: 0;
  padding: 0;
  list-style: none;
  overflow: hidden;
  background-color: #f1f0f0;
}

.header li a {
  display: flex;
  padding: 20px 20px;
  border-bottom: 1px solid #b6b6b6;
  text-decoration: none;
  color:#828383;
  font-weight: bold;
  left: 0;
}
.active {
  color:#f16101;
}

.header li a:hover,
.header .menu-btn:hover {
  color: #f16101;
}
.header li a:active,
.header .menu-btn:active {
  color: #f16101;
}

.header .logo {
  display: block;
  float: left;
  font-size: 2em;
  padding: 20px 20px;
  text-decoration: none;
}

/* menu */

.header .menu {
  clear: both;
  max-height: 0;
  transition: max-height .2s ease-out;
}

/* menu icon */

.header .menu-icon {
  cursor: pointer;
  display: inline-block;
  float: right;
  padding: 45px 20px 10px 20px;
  position: relative;
  user-select: none;
  color: #022c46;
  
}

.header .menu-icon .navicon {
  background: #022c46;
  display: block;
  height: 3px;
  position: relative;
  transition: background .2s ease-out;
  width: 25px;
}

.header .menu-icon .navicon:before,
.header .menu-icon .navicon:after {
  background: #022c46;
  content: '';
  display: block;
  height: 100%;
  position: absolute;
  transition: all .2s ease-out;
  width: 100%;
}

.header .menu-icon .navicon:before {
  top: 5px;
}

.header .menu-icon .navicon:after {
  top: -5px;
}

/* menu btn */

.header .menu-btn {
  display: none;
}

.header .menu-btn:checked ~ .menu {
  max-height: 390px;
}

.header .menu-btn:checked ~ .menu-icon .navicon {
  background: transparent;
}

.header .menu-btn:checked ~ .menu-icon .navicon:before {
  transform: rotate(-45deg);
}

.header .menu-btn:checked ~ .menu-icon .navicon:after {
  transform: rotate(45deg);
}

.header .menu-btn:checked ~ .menu-icon:not(.steps) .navicon:before,
.header .menu-btn:checked ~ .menu-icon:not(.steps) .navicon:after {
  top: 0;
}
}
</style>